import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import SendIcon from '@mui/icons-material/Send';
import DecorativeCubes from '../components/DecorativeCubes';

const RequestPage = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={6} maxCubes={10} />
      <Header />
      
      <Box sx={{ py: 8, backgroundColor: '#f9f9f9', position: 'relative', zIndex: 2 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <SendIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: 'primary.main',
              }}
            >
              Оставить заявку
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Заполните форму, и наши специалисты свяжутся с вами
            </Typography>
          </Box>
        </Container>
      </Box>
      
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <ContactForm />
      </Box>

      <Footer />
    </Box>
  );
};

export default RequestPage;
